import React from "react";
import ServicesDetail from "../ServicesDetail/ServicesDetail";
import ServicesImg from "../ServicesImg/ServicesImg";
import Services1 from "../../img/Group_services-1.png";
import "./Services.css";
const Services = () => {
  return (
    <div className="services">
      <h3>Why Hishabee Business Manager?</h3>
      <p>
        Hishabee Business Manager is extremely easy to use Business Solution on
        your mobile with loads of cool features.
      </p>
      <div className="info-services">
        <div className="first-info" style={{ marginLeft: "50px" }}>
          <ServicesDetail className='feature-first '
            txt1={`Bangla and English Language`}
            txt2={`Hishabee Business Manager has been developed keeping the people of Bangladesh in mind. That is why we built the entire application in Bangla and English.`}
          />
          <ServicesImg img={Services1} className='feature-second' />
        </div>
        <div className="second-info" style={{ marginRight: "50px" }}>
          <ServicesImg img={Services1} className='feature-first'/>
          <ServicesDetail className='feature-second services-text'
            extra={{ marginRight: "50px" }}
            textRight={{ textAlign: "right !important" }}
            txt1={`Access to Real-Time Reports`}
            txt2={`We value you as a seller and thus Hishabee gives you instant Sales Reports. Inventory Reports and Expenses Report from a click of a button. You can see everything that happens in your store from the comfort of your home.`}
          />
        </div>
        <div className="third-info" style={{ marginLeft: "50px" }}>
          <ServicesDetail className='feature-first'
            txt1={`Tally Package (Free)`}
            txt2={`Keep track of all your day to day business transaction on your phone
              Faster data input
              automated reports of sales and expenses
              Due list management
              Top up and earn more`}
          />
          <ServicesImg img={Services1}  className='feature-second'/>
        </div>
        <div className="fourth-info" style={{ marginRight: "50px" }}>
          <ServicesImg img={Services1} className='feature-first'/>
          <ServicesDetail className='feature-second services-text'
            extra={{ marginRight: "50px" }}
            textRight={{ textAlign: "right !important" }}
            txt1={`24/7 Customer Support`}
            txt2={`We are here to support you with any question or concerns. Our professional support team will be able to assist you with your new Hishabee Business Manager Mobile Application. We are always available over online chat support, phone call or in-person consultation.`}
          />
        </div>
      </div>
    </div>
  );
};

export default Services;
